import { environment } from '@environments/environment';

export class ProgramFormConstant {
  public static programs = environment.serverUri + `api/${environment.apiVersion}/programs`;

  public static form = {
    detail: (programId: string, formType: string) => {
      return `${ProgramFormConstant.programs}/${programId}/forms/${formType}`;
    },
    detailForStage: (programId: string, stageId: string, formType: string) => {
      return `${ProgramFormConstant.programs}/${programId}/stages/${stageId}/forms/${formType}`;
    },
    jsonDetailForStage: (programId: string, stageId: string, formType: string) => {
      return `${ProgramFormConstant.programs}/${programId}/stages/${stageId}/forms/${formType}/json`;
    },
    statusForStage: (programId: string, stageId: string, formType: string) => {
      return `${ProgramFormConstant.programs}/${programId}/stages/${stageId}/forms/${formType}/status`;
    }
  };

  public static newForms = {
    find: (programId: string) => {
      return `${ProgramFormConstant.programs}/${programId}/program-forms`;
    },
    create: (programId: string) => {
      return `${ProgramFormConstant.programs}/${programId}/program-forms`;
    },
    update: (programId: string, programFormsId: string) => {
      return `${ProgramFormConstant.programs}/${programId}/program-forms/${programFormsId}`;
    }
  };

  public static milestoneForms = {
    create: (programId: string, milestoneConfigId: string) => {
      return `${ProgramFormConstant.programs}/${programId}/milestone-config/${milestoneConfigId}/forms`;
    },
    delete: (programId: string, milestoneConfigId: string) => {
      return `${ProgramFormConstant.programs}/${programId}/milestone-config/${milestoneConfigId}/forms`;
    },
    get: (programId: string, milestoneConfigId: string) => {
      return `${ProgramFormConstant.programs}/${programId}/milestone-config/${milestoneConfigId}/forms`;
    },
  };
}
